<template>
  <div class="po-toast">
    <transition-group appear name="po-toast-fade" tag="div">
      <div v-for="item in items" :key="item.id" @click="activate(item)">
        <wo-alert :mod-error="item.error"><po-display :value="item" /></wo-alert>
      </div>
    </transition-group>
  </div>
</template>
<script>

import _ from 'lodash'
import { mapState } from 'vuex'

import { clearAlerts } from '@/store'

const defaultTimout = 5000

export default {
  props: {
    value: undefined,
    modScroll: Boolean
  },
  data () {
    return {
      counter: 0,
      items: []
    }
  },
  computed: mapState({
    queue: state => state.alert.queue
  }),
  watch: {
    queue () {
      this.handleQueue()
    }
  },
  created () {
    this.handleQueue()
  },
  methods: {
    handleQueue () {
      if (!_.isEmpty(this.queue)) {
        _.each(this.queue, this.addItem)
        clearAlerts(this.$store)
      }
    },
    addItem (item) {
      const alert = Object.assign({
        id: this.counter++
      }, item)

      if (!alert.error) {
        setTimeout(() => {
          this.items = _.without(this.items, alert)
        }, defaultTimout)
      }

      this.items.push(alert)
    },
    activate (item) {
      if (item.route) {
        this.$router.push(item.route)
      }
      this.items = _.without(this.items, item)
    }
  }
}
</script>

<style lang="scss">

$toast-width: 500px;
$toast-top-offset: 100px;
$toast-spacing: 15px;

.po-toast {
  position: fixed;
  bottom: 0;
  width: 100%;
  right: 0;
  padding: 0 $toast-spacing;

  max-width: $toast-width;

  cursor: pointer;

  .wo-alert {
    margin: 0;
    max-width: 100%;
    margin-bottom: $toast-spacing;
  }
}

.po-toast-fade-enter-active, .po-toast-fade-leave-active {
  transition: all .5s ease-in-out;
}
.po-toast-fade-enter, .po-toast-fade-leave-to {
  opacity: 0;
  transform: translateX($toast-width);
}
</style>
